import type { MayBe } from 'types/common';

/**
 * Browser-support detection for Intl feature-proposal additions that throw on older engines
 * instead of silently ignoring the unsupported option (e.g. `RangeError`), so a feature-detect
 * check must happen before ever constructing the throwing formatter.
 */
export class IntlSupport {
  private static negativeSupported: MayBe<boolean>;

  /**
   * `signDisplay: 'negative'` is a late addition to the Intl.NumberFormat spec (v3) and throws a
   * RangeError on engines that don't recognise it yet — e.g. Samsung Internet < 20. Support is
   * detected once and cached so unsupported browsers don't retry the throwing constructor on
   * every format call.
   */
  static get negative(): boolean {
    if (IntlSupport.negativeSupported === undefined) {
      try {
        const formatter = new Intl.NumberFormat('en', { signDisplay: 'negative' });
        IntlSupport.negativeSupported = formatter.resolvedOptions().signDisplay === 'negative';
      } catch {
        IntlSupport.negativeSupported = false;
      }
    }

    return IntlSupport.negativeSupported;
  }
}
